import { Button, Container, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { CheckBoxField, ImageUploader, LineBreaker, DatePicker } from '../../../../atomicComponent/AtomicComponents';
import { useFormSubmit } from '../../../../hook/useFormSubmit';
import api from '../../../../data/api';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { handleErrorResponse } from '../../../../utils/handleErrorResponse';
import dayjs from 'dayjs';
import { newYorkMidnight } from '@/utils/helper';

export const ProduceBanners = ({ initialValues, onSubmit }) => {
	const navigate = useNavigate();

	const [bannerDetails, setBannerDetails] = React.useState({
		_id: '',
		title: '',
		image: null,
		isActive: false,
		releaseDate: dayjs(new Date()).format('YYYY-MM-DD'),
		dateOnly: dayjs(new Date()).format('YYYY-MM-DD')
	});

	useEffect(() => {
		if (initialValues) {
			setBannerDetails(initialValues);
		}
	}, [initialValues]);

	const getCurrentDate = () => {
		var timestamp = Date.parse(bannerDetails?.releaseDate);

		if (isNaN(timestamp) === false) {
			return new Date(timestamp);
		} else {
			return dayjs(new Date()).format('YYYY-MM-DD');
		}
	};

	const onReleaseDateChange = date => {
		const dateOnly = date ? dayjs(date).format('YYYY-MM-DD') : '';

		setBannerDetails(prev => ({
			...prev,
			releaseDate: dateOnly,
			dateOnly
		}));
	};

	const handleChange = prop => event => {
		const value = event.target ? event.target.value : event;
		setBannerDetails({ ...bannerDetails, [prop]: value });
	};

	const handleSubmit = useFormSubmit(async (event, token) => {
		event.preventDefault();

		if (!validateForm()) return;
		let submitImage = bannerDetails.image;

		if (bannerDetails.image instanceof File) {
			const imageUrl = await api.fileUploadApi(bannerDetails.image);
			setBannerDetails(prev => ({ ...prev, image: imageUrl?.data?.cdnLink }));
			submitImage = imageUrl?.data?.cdnLink;
			if (handleErrorResponse(imageUrl)) return;
		}
		try {
			const data = { ...bannerDetails };

			const response = await onSubmit({
				id: data._id ? data._id : '',
				title: data.title,
				imageLink: submitImage,
				releaseDate: data.releaseDate,
				dateOnly: data.releaseDate,
				isActive: data.isActive,
				token
			});

			if (handleErrorResponse(response)) return;
			toast.success(response.message);
		} catch (err) {
			console.log(err);
		}

		resetForm();
	});

	// Function to validate form fields
	const validateForm = () => {
		if (!bannerDetails.image) {
			toast.error('Please select an image');
			return false;
		}

		if (!bannerDetails.title) {
			toast.error('Please enter a title');
			return false;
		}

		return true;
	};

	// Function to reset form fields after submission
	const resetForm = () => {
		setBannerDetails({
			title: '',
			image: null,
			isActive: false,
			releaseDate: new Date()
		});
		navigate('/AdminDashboard/banners');
	};

	return (
		<React.Fragment>
			<Container maxWidth="lg">
				<form onSubmit={handleSubmit}>
					<TextField
						variant="outlined"
						label="Title"
						fullWidth
						value={bannerDetails.title}
						onChange={handleChange('title')}
					/>
					<LineBreaker />
					<ImageUploader label="Upload Banner" value={bannerDetails.image} handleImageChange={handleChange('image')} />
					<LineBreaker />
					<div style={{ display: 'flex', gap: '3rem', width: '100%', height: '40px' }}>
						<div
							style={{
								position: 'relative',
								width: '100%',
								height: '100%',
								zIndex: 1000
							}}
						>
							<DatePicker
								minDate={newYorkMidnight()}
								value={getCurrentDate()}
								handleDateChange={onReleaseDateChange}
								dateFormat="MMMM d, yyyy"
							/>
						</div>
					</div>

					<LineBreaker />
					<CheckBoxField
						label={'Immediately show banner (This will ignore the release date)'}
						value={bannerDetails.isActive}
						handleChange={handleChange('isActive')}
					/>
					<LineBreaker />
					<Button sx={{ backgroundColor: '#7367f0' }} variant="contained" color="secondary" onClick={handleSubmit}>
						Submit
					</Button>
				</form>
			</Container>
		</React.Fragment>
	);
};
